import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const CustomPageDetailContentCatalogLargeLayoutItem = (props) => {

  let {
    pageBlockItem,
  } = props;

  let {t} = useTranslation('catalog');

  return (
    <li className="col px-0">
      <figure className="img">
        <a data-toggle="modal" data-target="#modalWindow02">
          <span><img className="m_imgShadow" src={pageBlockItem.itemImageUrl} alt=""/></span>
        </a>
        <div className="m_previewBtn"><a data-toggle="modal" data-target={"#catalog_modal_" + pageBlockItem.pageBlockItemId}>プレビュー</a>
        </div>
      </figure>
      <div className="dtl">
        <p className="ttl"><span><a target="_blank" href={pageBlockItem.itemUrl}>{pageBlockItem.itemName}</a></span></p>
        <p className="subTxt"><a href={pageBlockItem.itemCompanyUrl}>{pageBlockItem.itemCompanyName}</a></p>
        <p className="label">{pageBlockItem.itemCategoryName}</p>
        <p className="subTxt" style={{whiteSpace: 'pre-wrap'}}>{pageBlockItem.itemDescription}</p>
        <div className="btn-wrap">
          <a data-toggle="modal" href="#" className="btn btn-default btn-xl" data-target={"#catalog_modal_" + pageBlockItem.pageBlockItemId}>
            <i className="fa fa-search-plus"></i> {t('catalog.previewBtn')}
          </a>
          <a id="previewCatalogDownloadLink" href="#" className="js_modal btn btn-primary btn-xl" data-toggle="modal" data-target="#catalogDownloadModal" data-company_id={pageBlockItem.extendProperties.cluezCompanyId} data-catalog_id={pageBlockItem.extendProperties.cluezCatalogId}>
            <i className="fa fa-download fa-fw"></i> {t('catalog.downloadBtn')}
          </a>
        </div>
      </div>
    </li>
  );

};

CustomPageDetailContentCatalogLargeLayoutItem.propTypes = {
  pageBlockItem: PropTypes.any.isRequired
};

export default CustomPageDetailContentCatalogLargeLayoutItem;
